"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPERTY = exports.LAWSUIT = exports.ENVIRONMENTAL_VIOLATION = exports.ENVIRONMENTAL_PROCEEDING = exports.ENVIRONMENTAL_HAZARD_RELEASE = exports.CONSULT = exports.CASE = void 0;
exports.CASE = "case";
exports.CONSULT = "consult";
exports.ENVIRONMENTAL_HAZARD_RELEASE = "environmentalHazardReleas";
exports.ENVIRONMENTAL_PROCEEDING = "environmentalProceeding";
exports.ENVIRONMENTAL_VIOLATION = "environmentalViolation";
exports.LAWSUIT = "lawsuit";
exports.PROPERTY = "property";